module.exports = __webpack_public_path__ + "img/user-11.e47fb63a.svg";